<script>
  import { each } from "svelte/internal";
  import {  preguntas,updateD,addDoc } from "../../stores/CES";
  import { modalStore, dataEdit } from "../../stores/service";
  import db from "../../firebase";
  import { navigate } from "svelte-routing";
  import { userRol } from "../../stores/user";
  import { onMount } from "svelte";
  import { readonly } from "svelte/store";
  let controls = {
    input: false,
    save: false,
    cancel: true,
    mess:'',
    main:0
  };

  let dataList = {
    tipo: 0,
    pregunta: "",
    check: [],
    checkboxSize: 0,
    nPregunta:0
  };
  onMount(async () => {
    if (!$userRol) {
      navigate("/", { replace: true });
    }



    if ($dataEdit.opc === 200) {
      document.title = "Ratingg | Editar";
      dataList = $dataEdit.data;
      $dataEdit = {};
      if (dataList.tipo == 1) {
        dataList.checkboxSize = `${dataList.checks[0].checks.length}`;
        dataList.check = dataList.checks[0].checks;
      }
      dataList.checkboxSize = 0
      dataList.check = [];
      controls.main =1;
    } else {
      document.title = "Ratingg | Nuevo";
      
      controls.main=2;
    }
  });

  $: {

    if(controls.main === 2){
      dataList.nPregunta = $preguntas.length+1;
      /* console.log('preguntas',$preguntas) */
    }

    switch ($modalStore.opc) {
      case 100:
        if (!$modalStore.open) {
          $modalStore.opc = null;
          controls.input = false;
        }
        break;

      default:
        break;
    }

    /* dataList.valid = [dataList.pregunta]; */
/*     console.log("0 >= dataList.pregunta.length && 0 < parseInt(dataList.tipo",0 < dataList.pregunta.length && 0 < parseInt(dataList.tipo))
 */
    if (6 > dataList.pregunta.length) {
      controls.mess = "La pregunta es corta"
    }else{
      controls.mess = ""
    }

    if (5 < dataList.pregunta.length && 0 < parseInt(dataList.tipo)) {


      /* console.
      (
        "dataList.tipo == 1",
        dataList.tipo == 1
      ); */

      if (dataList.tipo == 1) {
        /* console.log(
        "0 < dataList.checkboxSize",
        0 <= dataList.checkboxSize
      ); */
        if (0 <= dataList.checkboxSize) {
          controls.save = true;
          dataList.check.forEach((item) => {
            
            if (0 >= item.contenido.length) {
              controls.save = false;
            }
          });
        } else {
          controls.save = false;
        }
      } else {
        controls.save = true;
      }


    } else {
      controls.save = false;
    }
    
  }

  let rango;
  function CreateQ() {
    const data = {
      }
      data.tipo = dataList.tipo;
      data.nPregunta = dataList.nPregunta;
      data.pregunta = dataList.pregunta;
      if (dataList.tipo == 1) {
        data.checkboxOpc=dataList.checkboxOpc;
        data.checkboxSize=dataList.checkboxSize;
        data.checks = [
          {
            check:dataList.check
          }
        ]
      } 
    if (controls.main === 1) {
      updateD({
        data:data,
        id:dataList.id,
        collection:'preguntas'
      })
    } else {
      addDoc(
        {
        data:data,
        collection:'preguntas'
        }
      )
    }
    navigate("/panel", { replace: true });
  }

  function validQ(e) {
    let regex = /^[a-zA-Z0-9\s?!-]{0,50}$/u;
    if (!regex.test(e.target.value)) {
      controls.input = true;
      $modalStore.body = "Formule correctamente la pregunta";
      $modalStore.mess = false;
      $modalStore.opcS = "Aceptar";
      $modalStore.ans = false;
      $modalStore.opc = 100;
      $modalStore.open = true;
    } else {
      controls.input = false;
    }
  }

  function genopc() {
    let data = []
    let index;
    if (dataList.hasOwnProperty('check') ) {
        data = dataList.check;
        } 
        dataList.check = []
    for (index = 0; index <= parseInt(dataList.checkboxSize); index++) {
    
      if (index <= data.length - 1) {
        if (data[index].hasOwnProperty('contenido')) {
          dataList.check[index] = data[index];
        } else {
          dataList.check[index] = [{
            contenido: "",
            n: index + 1,
          }];
        }
      } else {
        dataList.check[index] = {
          contenido: "",
          n: index + 1,
        };
      }
    }
  }
</script>

<form class="was-validated">
  <div class="mb-3">
    <label for="validationTextarea">Nueva pregunta # {dataList.nPregunta}.-</label>
    <textarea
      class="form-control is-invalid"
      id="validationTextarea"
      placeholder=""
      bind:value={dataList.pregunta}
      on:input={(e) => validQ(e)}
      readonly={controls.input}
      required
    />
    <!-- <div class="invalid-feedback">
        Por favor escriba la pregunta.
      </div> -->
  </div>
<p>{controls.mess}</p>
  <div class="form-group">
    <label for="validationTextarea">Tipo de sondeo</label>
    <select class="custom-select" bind:value={dataList.tipo} required>
      <option value="">Seleccionar</option>
      <option value="1">Multiple</option>
      <option value="2">Botonera</option>
      <option value="3">Rango</option>
      <option value="4">Normal</option>
    </select>
    <div class="invalid-feedback">Seleccione uno.</div>
  </div>
  {#if dataList.tipo == 1}
    <div class="form-group">
      <label for="validationTextarea1">Tipo de checkbox</label>
      <select class="custom-select" bind:value={dataList.checkboxOpc} required>
        <option value="">Seleccionar</option>
        <option value="1">Multiple</option>
        <option value="2">Único</option>
      </select>
      <div class="invalid-feedback">Seleccione uno.</div>
    </div>
  {/if}

  {#if dataList.tipo == 1}
    <div class="form-group">
      <label for="validationTextarea2">Cantidad de respuestas</label>
      <select
        class="custom-select"
        bind:value={dataList.checkboxSize}
        on:change={genopc}
        required
      >
        <option value="">Seleccionar</option>
        <option value="0">1</option>
        <option value="1">2</option>
        <option value="2">3</option>
        <option value="3">4</option>
        <option value="4">5</option>
      </select>
      <div class="invalid-feedback">Seleccione uno.</div>
    </div>
  {/if}

  {#if dataList.checkboxOpc == 1 && dataList.tipo == 1 && dataList.checkboxSize !== 0}
    <label>Complete los sondeos correspondientes</label>
    {#each dataList.check as check (check.n)}
      <br />
      <label for="validationTextarea3">Opción {check.n}</label>
      <div class="input-group mb-3">
        <div class="input-group-prepend">
          <div class="input-group-text">
            <input
              type="checkbox"
              aria-label="Checkbox for following text input"
            />
          </div>
        </div>
        <input
          type="text"
          class="form-control"
          aria-label="Text input with checkbox"
          bind:value={check.contenido}
          on:input={(e) => validQ(e)}
          readonly={controls.input}
          required
        />
      </div>
    {/each}
  {/if}

  {#if dataList.checkboxOpc == 2 && dataList.tipo == 1 && dataList.checkboxSize !== 0}
    <label>Complete los sondeos correspondientes</label>
    {#each dataList.check as check (check.n)}
      <br />
      <label for="validationTextarea4">Opción {check.n}</label>
      <div class="input-group mb-3">
        <div class="input-group-prepend">
          <div class="input-group-text">
            <input type="radio" aria-label="Radio for following text input" />
          </div>
        </div>
        <input
          type="text"
          class="form-control"
          aria-label="Text input with radio button"
          bind:value={check.contenido}
          on:input={(e) => validQ(e)}
          readonly={controls.input}
          required
        />
      </div>
    {/each}
  {/if}

  {#if controls.save}
    
  

  <button class="btn btn-primary" on:click|preventDefault={CreateQ}
    >Guardar</button
  >
  {:else}
  <button class="btn btn-danger" on:click|preventDefault={()=>navigate("/panel", { replace: true })}
    >Cancelar</button
  >
  {/if}
</form>

<div />
<br /><br />

<!-- Ejemplo -->
{#if 0 < dataList.tipo}
  <div class="card card-success">
    <div class="card-header">
      <h3 class="card-title">Ejemplo</h3>
    </div>
    <div class="card-body">
      {#if dataList.tipo == 1 && dataList.checkboxOpc == 0}
        <div class="row">
          <div class="col-sm-6">
            <!-- checkbox -->
            <div class="form-group clearfix">
              <div class="icheck-primary d-inline">
                <input type="checkbox" id="checkboxPrimary1" checked />
                <label for="checkboxPrimary1" />
              </div>
              <div class="icheck-primary d-inline">
                <input type="checkbox" id="checkboxPrimary2" />
                <label for="checkboxPrimary2" />
              </div>
              <div class="icheck-primary d-inline">
                <label for="checkboxPrimary3"> Multiple </label>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <!-- radio -->
            <div class="form-group clearfix">
              <div class="icheck-primary d-inline">
                <input type="radio" id="radioPrimary1" name="r1" checked />
                <label for="radioPrimary1" />
              </div>
              <div class="icheck-primary d-inline">
                <input type="radio" id="radioPrimary2" name="r1" />
                <label for="radioPrimary2" />
              </div>
              <div class="icheck-primary d-inline">
                <label for="radioPrimary3"> Único </label>
              </div>
            </div>
          </div>
        </div>
      {/if}

      {#if dataList.tipo == 3}
        <div class="row">
          <div class="col-12 p-2">
            <div class="question">
              <span class="number">{dataList.nPregunta}.</span>
              {dataList.pregunta !== ""
                ? dataList.pregunta
                : "Aspecto a evaluar"}
            </div>
            {#if dataList.rango === 0}
              <span class="text-danger"> Muy Malo</span>
            {/if}
            {#if dataList.rango === 1}
              <span class="text-warning"> Malo</span>
            {/if}
            {#if dataList.rango === 2}
              <span class="text-secondary"> Regular</span>
            {/if}
            {#if dataList.rango === 3}
              <span class="text-primary"> Bueno</span>
            {/if}
            {#if dataList.rango === 4}
              <span class="text-success"> Muy Bueno</span>
            {/if}
            <!-- <div>{cambiarValor(rango)}</div> -->
            <div class="col-12">
              <input
                type="range"
                min="0"
                max="4"
                step="1"
                class="custom-range custom-range-teal"
                id="customRange3"
                bind:value={dataList.rango}
              />
            </div>
          </div>
        </div>
      {/if}

      {#if dataList.tipo == 1 && dataList.checkboxOpc == 2 && dataList.checkboxSize > 0 && 0 < dataList.check.length}
        <div class="question">
          <span class="number">{dataList.nPregunta}.</span>
          {dataList.pregunta !== "" ? dataList.pregunta : "Aspecto a evaluar"}
        </div>

        {#each dataList.check as check (check.n)}
          <div class="options">
            <div class="form-group clearfix">
              <div class="icheck-primary d-inline">
                <input
                  type="radio"
                  id="radioPrimary{check.n}"
                  name="r1"
                  checked
                />
                <label for="radioPrimary{check.n}">
                  {check.contenido}
                </label>
              </div>
            </div>
          </div>
        {/each}
      {/if}
      {#if dataList.tipo == 1 && dataList.checkboxOpc == 1 && dataList.checkboxSize > 0 && 0 < dataList.check.length}
        <div class="question">
          <span class="number">{dataList.nPregunta}.</span>
          {dataList.pregunta !== "" ? dataList.pregunta : "Aspecto a evaluar"}
        </div>
        {#each dataList.check as check (check.n)}
          <div class="options">
            <div class="form-group clearfix">
              <div class="icheck-primary d-inline">
                <input
                  type="checkbox"
                  id="radioPrimary{check.n}"
                  name="r1"
                  checked
                />
                <label for="radioPrimary{check.n}">
                  {check.contenido}
                </label>
              </div>
            </div>
          </div>
        {/each}
      {/if}

      {#if dataList.tipo == 2}
        <div class="question">
          <span class="number">{dataList.nPregunta}.</span>
          {dataList.pregunta !== "" ? dataList.pregunta : "Aspecto a evaluar"}
        </div>
        <div class="row d.flex align-items-center justify-content-center">
          <!-- <label>Aspecto a evaluar </label> -->
          <div class="col-12 p-2">
            <button
              type="button"
              class="btn btn-block btn-lg btnsystem"
              style="background-color:green">Bueno</button
            >
          </div>
          <div class="col-12 p-2">
            <button
              type="button"
              class="btn btn-block btn-lg btnsystem"
              style="background-color:yellow;color:black;">Regular</button
            >
          </div>
          <div class="col-12 p-2">
            <button
              type="button"
              class="btn btn-block btn-lg btnsystem"
              style="background-color:red">Malo</button
            >
          </div>
        </div>
      {/if}

      {#if dataList.tipo == 4}
        <form class="">
          <div class="question">
            <span class="number">{dataList.nPregunta}.</span>
            {dataList.pregunta !== "" ? dataList.pregunta : "Aspecto a evaluar"}
          </div>
          <div class="mb-3">
            <textarea class="form-control" id="" placeholder="" />
            <!-- <div class="invalid-feedback">
    Por favor escriba la pregunta.
  </div> -->
          </div>
        </form>
      {/if}
    </div>
  </div>
{/if}

<style>
  .question {
    margin: 20px 0;
    font-weight: bold;
  }

  .options {
    margin-left: 20px;
  }

  .option {
    margin: 10px 0;
  }

  .number {
    font-size: 1.2em;
    margin-right: 10px;
  }

  .checkbox-option {
    display: flex;
    align-items: center;
  }

  .checkbox-input {
    margin-right: 10px;
  }
</style>
